import {Component, Input, OnInit} from '@angular/core';
import {Person} from '../../class/person';
import {Desktop} from '../../class/desktop';
import {Debt} from '../../class/debt';
import {NbDialogService} from '@nebular/theme';
import {ConfirmMessageDialogComponent} from '../dialog/confirm-message-dialog/confirm-message-dialog.component';
import {PersonKind} from '../../class/person-kind.enum';

@Component({
  selector: 'app-person-income-component',
  templateUrl: './person-income-component.component.html',
  styleUrls: ['./person-income-component.component.css']
})
export class PersonIncomeComponentComponent implements OnInit {

  @Input()
  family: Person[];

  @Input()
  debets: Debt[];

  @Input()
  desktop: Desktop;

  @Input()
  familyCost: number;

  @Input()
  theoryIncomeOnly: boolean;

  readonly kindChild = PersonKind.CHILD;

  constructor(private dialogService: NbDialogService) {
  }

  ngOnInit() {
    if (!this.desktop) {
      this.desktop = new Desktop();
      this.desktop.theoryIncomeOption = this.theoryIncomeOnly;
    }
  }

  calRisparimo() {

    let ret = 0;

    this.family.forEach(person => {
      ret += person.income + person.secondIncome;
    });

    const rate = this.desktop.savingRate / 100;

    this.desktop.savingValue = (ret * rate);

    this.calcAnnualOrdinalCost(0);
  }

  calcAnnualOrdinalCost(theoryAnnualCost: number) {

    // get family total income
    let totalIncome = 0;
    let totalDebts = 0;
    let saveingValue = 0;

    if (!this.desktop.theoryIncomeOption) {
      this.family.forEach(value => {
        totalIncome += value.income + value.secondIncome;
      });

      saveingValue = this.desktop.savingValue;
    }

    this.debets.forEach(value => {
      totalDebts += value.debtYear;
    });

    this.desktop.annualOrdinalCost = totalIncome - totalDebts - saveingValue;
  }

  private getTotalIncome() {
    let ret = -1;

    this.family.forEach(value => {
      ret += value.income + value.secondIncome;
    });

    return ret;
  }

  check(value: boolean) {
    if (value && this.getTotalIncome() > 0) {
      // show alert dialog
      this.dialogService.open(ConfirmMessageDialogComponent, {
          context:
            {
              title: 'Attenzione',
              msg: 'Abilitando questa opzione i redditi verranno azzerati, vuoi continuare?'
            }
        }
      ).onClose.subscribe(result => {
        if (result) {
          // remove income foreach person
          this.family.forEach(person => {
            person.income = 0;
            person.secondIncome = 0;
          });

          // reset saving rate
          this.desktop.savingRate = 0;
          this.desktop.annualOrdinalCost = 0;
        } else {
          this.desktop.theoryIncomeOption = false;
        }
      });
    }
  }

}
